export function FooterSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative py-12 sm:py-16 md:py-20 bg-black/50 backdrop-blur-sm border-t border-white/10">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center space-y-8 sm:space-y-12">
          {/* Logo Section */}
          <div className="relative">
            <h2 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-violet-400 to-purple-400 bg-clip-text text-transparent">
              Tehk Zone
            </h2>
            <p className="text-gray-400 text-sm mt-3 sm:mt-4 font-light">
              Bridging Creativity and Technology
            </p>
          </div>

          {/* Navigation Links */}
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 md:gap-8 text-sm px-4">
            <button 
              onClick={() => scrollToSection('showcase')}
              className="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer"
            >
              Core Values
            </button>
            <button 
              onClick={() => scrollToSection('products')}
              className="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('projects')}
              className="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer"
            >
              Who We Are
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer"
            >
              Contact
            </button>
          </div>

          {/* Social Media Icons */}
          <div className="flex items-center justify-center space-x-6 sm:space-x-8">
            <a href="#" className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">
              <i className="ri-linkedin-fill text-xl sm:text-2xl"></i>
            </a>
            <a href="#" className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">
              <i className="ri-twitter-x-fill text-xl sm:text-2xl"></i>
            </a>
            <a href="#" className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center text-gray-400 hover:text-white transition-colors duration-300 cursor-pointer">
              <i className="ri-facebook-fill text-xl sm:text-2xl"></i>
            </a>
          </div>

          {/* Divider */}
          <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent"></div>
          
          {/* Copyright */}
          <div className="text-gray-500 text-xs sm:text-sm font-light px-4">
            <p>© 2024 Tehk Zone Inc. All rights reserved.</p>
            <p className="mt-2">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-violet-400 transition-colors duration-300">
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
